import React from 'react';
import { Badge, BadgeProps } from '@amzn/awsui-components-console';
import { WorkflowIntention } from '@amzn/snow-nxt-workflow-service-typescript-client';

interface WorkflowIntentionDisplayProps {
	intention: WorkflowIntention;
}

interface IntentionConfig {
	label: string;
	color: BadgeProps['color']; 
}

const INTENTION_CONFIG: Record<WorkflowIntention, IntentionConfig> = {
	[WorkflowIntention.CREATE]: {
		label: 'Create',
		color: 'green',
	},
	[WorkflowIntention.UPDATE]: {
		label: 'Update',
		color: 'blue',
	},
	[WorkflowIntention.DELETE]: {
		label: 'Delete',
		color: 'red',
	},
};

const WorkflowIntentionDisplay: React.FC<WorkflowIntentionDisplayProps> = ({ intention }) => {
	const config = INTENTION_CONFIG[intention] ?? INTENTION_CONFIG[WorkflowIntention.CREATE];

	return <Badge color={config.color}>{config.label}</Badge>;
};

export default WorkflowIntentionDisplay;
